import * as ordersConstant from './constants'
const initialState = {
  list: [],
  item: {},
  type: ordersConstant.ORDERS_LIST_INITING,
  listRequesting: false,
  requesting: false,
  successful: false,
  messages: [],
  errors: [],
  ordersApproveChecked: [],
  formData: {},
  approvedMessages: [],
  approvedErrors: [],
  callback: () => {}
}
const reducer = function ordersReducer(state = initialState, action) {
  switch (action.type) {
    case ordersConstant.ORDERS_LIST_NV_REQUESTING:
      return {
        ...state,
        list: [],
        item: {},
        type: action.type,
        messages: [],
        errors: [],
      }
    case  ordersConstant.ORDERS_SET_CALLBACK:
      return {
        ...state,
        callback: action.payload,
      }
    case  ordersConstant.ORDERS_APPROVE_SET_LIST:
      return {
        ...state,
        ordersApproveChecked: action.payload,
      }
    case  ordersConstant.ORDERS_APPROVE_LIST_REQUESTING:
      return {
        ...state,
        formData: action.payload,
        callback: action.callback,
        approvedMessages: [],
        approvedErrors: [],
      }
    case  ordersConstant.ORDERS_SET_APPROVE_MESSAGE:
      let approvedMessages = []
      if (action.payload != "") {
        approvedMessages = [{
          body: action.payload,
          time: new Date(),
        }]
      }
      return {
        ...state,
        approvedErrors: [],
        approvedMessages: approvedMessages,
      }
    case  ordersConstant.ORDERS_SET_APPROVE_ERROR:
      let approvedErrors = []
      if (typeof action.payload === 'string') {
        if (action.payload != "") {
          approvedErrors = ({
            body: action.payload,
            time: new Date().getTime(),
          })
        }
      } else {
        approvedErrors = action.payload.map((message, index) => { 
          return {
            body: message,
            time: index,
          }
        })
      }
      return {
        ...state,
        approvedMessages: [],
        approvedErrors: approvedErrors,
      }
    case ordersConstant.ORDERS_LIST_NV_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: action.data,
        messages: [],
        errors: [],
      }

    case ordersConstant.ORDERS_LIST_NV_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: [],
        item: {},
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    case ordersConstant.ORDERS_LIST_REQUESTING:
      return {
        ...state,
        list: [],
        item: {},
        type: action.type,
        listRequesting: true,
        messages: [{
          body: 'Fetching data...!',
          time: new Date(),
        }],
        errors: [],
        ordersApproveChecked: [],
        approvedMessages: [],
        approvedErrors: [],
        formData: {},
        callback: () => {},
      }

    case ordersConstant.ORDERS_LIST_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: action.data.records,
        item: action.data,
        listRequesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case ordersConstant.ORDERS_LIST_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: [],
        item: {},
        listRequesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    case ordersConstant.ORDERS_REMOVE_ITEM_REQUESTING:
      return {
        ...state, // ensure that we don't erase fetched ones
        list: [],
        item: {},
        type: action.type,
        requesting: true,
        successful: false,
        messages: [{
          body: 'Fetching data...!',
          time: new Date(),
        }],
        errors: [],
      }

    case ordersConstant.ORDERS_REMOVE_ITEM_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        list: [],
        item: action.data,
        type: action.type,
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case ordersConstant.ORDERS_REMOVE_ITEM_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        list: [],
        item: {},
        type: action.type,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    case ordersConstant.ORDERS_KHACHHANG_REQUESTING:
      return {
        ...state, // ensure that we don't erase fetched ones
        list: [],
        item: {},
        type: action.type,
        requesting: true,
        successful: false,
        errors: [],
      }

    case ordersConstant.ORDERS_KHACHHANG_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        list: action.data,
        type: action.type,
        requesting: false,
        successful: true,
      }

    case ordersConstant.ORDERS_KHACHHANG_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        list: [],
        type: action.type,
        requesting: false,
        successful: false,
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case ordersConstant.ORDERS_DAILY_REQUESTING:
      return {
        ...state, // ensure that we don't erase fetched ones
        list: [],
        item: {},
        type: action.type,
        requesting: true,
        successful: false,
        messages: [{
          body: 'Fetching data...!',
          time: new Date(),
        }],
        errors: [],
      }

    case ordersConstant.ORDERS_DAILY_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        item: {},
        list: action.data.records,
        type: action.type,
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case ordersConstant.ORDERS_DAILY_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case ordersConstant.ORDERS_EXPORT_XLS_REQUESTING:
      return {
        ...state,
        type: action.type,
        listRequesting: true,
        messages: [{
          body: 'Đang tải dữ liệu...!',
          time: new Date(),
        }],
        errors: [],
      }

    case ordersConstant.ORDERS_EXPORT_XLS_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case ordersConstant.ORDERS_EXPORT_XLS_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/views/Orders/reducer.js